import { render } from "./UserRemoveFromGroupModal.vue?vue&type=template&id=5cef5068&scoped=true&ts=true"
import script from "./UserRemoveFromGroupModal.vue?vue&type=script&lang=ts"
export * from "./UserRemoveFromGroupModal.vue?vue&type=script&lang=ts"

import "./UserRemoveFromGroupModal.vue?vue&type=style&index=0&id=5cef5068&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cef5068"]])

export default __exports__